var _rect, _g, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 230,
    viewBox: "0 0 285 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1039_45018",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 20,
    width: 185,
    height: 185
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.3355,
    y: 64.5254,
    width: 147.049,
    height: 147.049,
    transform: "rotate(-17.4211 40.3355 64.5254)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1039_45018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.419 166.427C102.762 166.946 101.197 166.821 99.7222 166.051C98.2527 165.283 97.2581 164.071 96.7384 162.415C96.2186 160.759 96.3425 159.196 97.1101 157.726C97.8803 156.251 99.0936 155.254 100.75 154.735L106.596 152.9L93.7552 111.978C91.2177 103.891 91.3984 95.9403 94.2975 88.1253C97.1978 80.3141 102.24 74.2113 109.423 69.8168L108.139 65.7246C107.374 63.2888 107.578 60.9515 108.751 58.7127C109.919 56.4713 111.72 54.9684 114.156 54.2041C116.592 53.4397 118.929 53.6439 121.168 54.8165C123.409 55.984 124.912 57.7856 125.677 60.2215L126.961 64.3136C135.367 63.8165 142.991 65.9448 149.834 70.6986C156.679 75.4563 161.37 81.8787 163.907 89.9656L176.748 130.888L182.594 129.053C184.25 128.533 185.814 128.659 187.284 129.431C188.758 130.197 189.754 131.408 190.274 133.065C190.794 134.721 190.668 136.285 189.897 137.755C189.13 139.229 187.919 140.225 186.263 140.745L104.419 166.427ZM150.844 171.124C147.629 172.133 144.518 171.852 141.512 170.282C138.502 168.71 136.492 166.316 135.483 163.101L158.867 155.763C159.876 158.978 159.596 162.091 158.027 165.1C156.454 168.107 154.059 170.115 150.844 171.124ZM118.288 149.231L165.056 134.556L152.215 93.6344C150.197 87.2038 146.18 82.4173 140.164 79.2749C134.148 76.1325 127.924 75.5702 121.494 77.588C115.063 79.6058 110.277 83.6229 107.134 89.6392C103.992 95.6555 103.429 101.879 105.447 108.309L118.288 149.231Z",
    fill: "#E30000"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.666,
    cy: 197.5,
    rx: 51,
    ry: 12.5,
    fill: "#FFE8E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationError);
export default __webpack_public_path__ + "static/media/notification-error.cba4792443d04575cea466dee419b384.svg";
export { ForwardRef as ReactComponent };